// extracted by mini-css-extract-plugin
export default {"root":"ErrorModal_root__jR5P9","buttonContainer":"ErrorModal_buttonContainer__SbWbT"};